import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsTreatment = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m45 24-6.151 14.85L24 45 9.151 38.85 8.385 37c2.054-.567 3.839-1.211 5.407-1.924 6.213-2.823 8.907-6.642 11.433-10.209 2.474-3.495 4.78-6.74 10.223-9.213 1.504-.683 3.255-1.31 5.324-1.862z" }), /* @__PURE__ */ _jsx("path", { d: "M38.849 9.151 39.613 11c-2.053.567-3.837 1.212-5.405 1.925-6.213 2.823-8.907 6.642-11.433 10.209-2.474 3.495-4.78 6.74-10.223 9.213-1.504.683-3.255 1.31-5.324 1.861L3 24 9.151 9.151 24 3z" })]
});
export default SvgMetricsTreatment;
